<script lang="ts" setup>
// Packages

// ---------------------------------------
// Composables
// ---------------------------------------
const route = useRoute();
const { t } = useI18n();

// ---------------------------------------
// State
// ---------------------------------------

const services = computed(() => [
  { title: 'Trabalhos de Umbanda', description: 'Todas as quartas-feiras a partir das 20:00h.' },
  { title: 'Sessões de Apometria', description: 'Todas as segundas-feiras, limitado em até 1 pessoa.' },
  { title: 'Psicografia', description: 'Cartas Consoladoras no último domingo do mês. (Até Abril de 2026)' },
]);

const metrics = computed(() => [
  { title: 'Cartas consoladoras', value: '2160+' },
  { title: 'Atendimento Fraterno', value: '1008+' },
  { title: 'Médiuns Últimos 5 Anos', value: '150+' },
  { title: 'Médiuns Batizados no Terreiro', value: '50+' },
]);

const memories = computed(() => [
  { src: 'https://assets.terreirovoritadasalmas.com.br/illustrations/festa-ogum-24-id-x-abu.jpg', description: 'Festa de Ogum - 2024. ' },
  { src: 'https://assets.terreirovoritadasalmas.com.br/illustrations/festa-ere-24-id-x-abu.jpg', description: 'Festa de Erê - 2024 ' },
  { src: 'https://assets.terreirovoritadasalmas.com.br/illustrations/festa-exu-22-id-x-abue.jpg', description: 'Festa de Exu - 2022' },
  { src: 'https://assets.terreirovoritadasalmas.com.br/illustrations/festa-oxossi-25-id-x-abu.jpg', description: 'Festa Oxóssi - 2025' },
  { src: 'https://assets.terreirovoritadasalmas.com.br/illustrations/festa-xango-24-id-x-abu.jpg', description: 'Festa de Xangô - 2024' },
  { src: 'https://assets.terreirovoritadasalmas.com.br/illustrations/IMG_20240925_180312.jpg', description: 'Festa de Erê - 2024' },
]);

// ---------------------------------------
// Meta
// ---------------------------------------

useHead(() => ({
  title: t('ABOUT_US'),
}));
</script>
<template>
  <main class="inline-block h-full">
    <header class="text-center mt-28 block mb-24">
      <span class="text-4xl md:text-6xl font-bold">
        {{ $t('ABOUT_US') }}
      </span>

      <div class="block my-6">
        <nuxt-link to="/" class="hover:underline">
          {{ $t('HOME') }}
        </nuxt-link>
        -
        <span>
          {{ $t('ABOUT_US') }}
        </span>
      </div>
    </header>
    <section>
      <!-- Introduction -->
      <div class="flex justify-between gap-10 flex-wrap xl:flex-nowrap">
        <figure>
          <img class="welcome-image" src="https://assets.terreirovoritadasalmas.com.br/about/pai_noe_2025-02-22_22-03-56.jpg" alt="Foto do Pai Noé de Xangô">
        </figure>
        <div class="flex justify-center flex-col pl-0 xl:pl-14">
          <span class="uppercase my-4 block">{{ $t('OUR_HISTORY') }}</span>
          <!-- <span class="block text-4xl font-bold my-2">Nemo enim ipsam voluptatem quia voluptas </span> -->
          <span class="my-2 text-justify">
            Após uma caminhada longa desde os cinco anos quando a mediunidade se manifestou pela primeira vez, tudo foi se moldando para que no momento certo tivéssemos a oportunidade de frequentar vários centros espiritas, Centro de Apometria, Terreiros de Umbanda, Candomblé (onde se manifestou Xango Agodo) e com isso, ampliando os nossos horizontes e experiência.
            Em 2015 nos foi mostrado que iriamos abrir um Terreiro de Umbanda pois, naquele ano, não estavamos frequentando nenhum centro, apenas exercíamos na minha própria residência trabalhos de psicografia, cartas consoladoras.
          </span>
          <span class="my-2 text-justify">
            Em 2019, fundamos o Terreiro de Umbanda Vó Rita das Almas, que antes era um Centro de Apometria no qual éramos o dirigente desde 2018.
            Devidamente orientado pela espiritualidade, foi feita a transição para Umbanda. 
          </span>
          <span class="my-2 text-justify">
            Todo o local foi ampliado (espaço físico) e adequado aos trabalhos espirituais.
            Já passaram pelo Terreiro mais de cem filhos/filhas e em razão do espaço ainda não comportar uma quantidade maior de médiuns, limitamos para no máximo quarenta e cinco médiuns.
          </span>
        </div>
      </div>
    </section>
    <section>
      <div class="flex-col items-center justify-center">
        <div class="w-full">
          <span class="block text-center uppercase my-4">{{ $t('WHAT_WE_DO') }}</span>
          <span class="block text-center text-4xl my-2">{{ $t('WHAT_WE_DO_TITLE') }}</span>
        </div>

        <!-- Services -->
        <div>
          <ul class="flex services-items mt-9 flex-wrap xl:flex-nowrap">
            <li v-for="(service, idx) in services" :key="idx" class="flex flex-col justify-center">
              <div class="flex flex-col justify-center items-center w-full h-full">
                <div class="flex flex-col items-center">
                  <span class="text-2xl text-center font-bold my-2">{{ service.title }}</span>
                  <span class="text-center my-2">{{ service.description }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <!-- TimeLine -->

    <AboutTimeLine />


    <!-- Metrics -->
    <section class="metrics">
      <div class="">
        <ul class="flex gap-9 lg:gap-0 justify-center w-full flex-wrap">
          <li
            v-for="(metric, idx) in metrics"
            :key="idx"
            class="flex flex-1 flex-col min-w-52 w-2/4 lg:w-1/4"
          >
            <span class="text-center text-2xl my-1">{{ metric.title }}</span>
            <span class="text-center my-1 text-6xl font-bold">{{ metric.value }}</span>
          </li>
        </ul>
      </div>
    </section>

    <section class="portifolio-section">
      <!-- Portifólio -->
      <div class="portifolio flex-col">
        <div class="w-full">
          <span class="block text-center uppercase my-4">{{ $t('PORTIFOLIO') }}</span>
          <span class="block text-center text-4xl my-2">{{ $t('OUR_MEMORIES') }}</span>
        </div>
        <ul class="flex gap-0 lg:gap-9 mt-9">
          <li
            v-for="(memory, idx) in memories"
            :key="idx"
            class="flex flex-col cursor-pointer overflow-hidden relative"
          >
            <div class="absolute bottom-0 left-0 p-4 text-white z-10 w-full">
              <span>
                {{ memory.description }}
              </span>
            </div>
            <img :src="memory.src" :alt="memory.description" class="w-full h-full object-cover hover:scale-110 transition-all duration-500 cursor-pointer" />
          </li>

        </ul>
      </div>
    </section>
    <section class="testimonials-section">
      <TestimonialsSection />
    </section>
  </main>
</template>
<style lang="scss" scoped>


main {
  background-color: #fff;
}

section {
  background-color: #fff; // apply background color to odd-numbered sections (1, 3, 5, etc.)

  > div {
    min-height: 780px;
    @apply py-24;
    @apply px-6;
    @apply mx-auto;
    @apply flex;
    @apply items-center;
    max-width: 1600px;
  }

  &:nth-child(odd) {
    background-color: unset; // apply background color to odd-numbered sections (1, 3, 5, etc.)
  }
}

@media (screen(lg)) {
  section {
    > div {
      @apply px-10;
    }
  }
}

.welcome-image {
  min-width: unset;
  width: 100%;
}

.services-items {
  @apply gap-6;

  li {
    background-color: #fff;
    @apply p-6;
    min-width: 380px;
    flex: 1;
    height: 360px;
  }
}

.metrics {
  min-height: unset;
  height: unset;
  color: #fff;
  background-color: var(--theme) !important;

  div {
    min-height: unset;
  }
}

.portifolio {
  ul {
    display: flex;
    flex-wrap: wrap;
    gap: 2.5rem;
  }

  li {
    div {
      pointer-events: none;
      background-color: rgba(0, 0, 0, 0.6);
      opacity: 0;
      visibility: hidden;
      backdrop-filter: blur(10px);

      @apply transition-all;
      @apply duration-500;
    }

    &:hover div {
      opacity: 1;
      visibility: visible;
    }

    &:nth-child(1) {
      grid-area: a;
    }
    &:nth-child(2) {
      grid-area: c;
    }
    &:nth-child(4) {
      grid-area: b;
    }
    &:nth-child(5) {
      grid-area: d;
    }
    &:nth-child(3) {
      grid-area: e;
    }
    &:nth-child(6) {
      grid-area: f;
    }
  }
}

.portifolio-section {
  background-color: #fff !important;
}

.testimonials-section {
  background-color: transparent;
}

// ---------------------------------------
// Responsive
// ---------------------------------------

@media (screen(xl)) {
  .portifolio {
    ul {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-template-rows: 300px 300px 300px 300px;
      gap: 30px 30px;
      grid-template-areas:
      "a a a a"
      "b c c d"
      "b c c d"
      "e f f f";
    }
  }

  .services-items {
    li {
      width: 410px;
    }
  }

  .welcome-image {
    min-width: 660px;
  }
}
</style>